import { createSelector } from 'reselect'

export const getMyBoardEnabled = (state, props) => {
  return state.kanbo.config.myBoard
}

export const getUserActivityConfig = (state, props) => {
  return state.kanbo.config.userActivity
}

export const getCurrentUserId = (state, props) => state.kanbo.currentUser.id

export default createSelector(
  [
    getMyBoardEnabled,
    getUserActivityConfig,
    getCurrentUserId
  ],
  (
    myBoardEnabled,
    userActivityConfig,
    currentUserId
  ) => ({
    myBoardEnabled,
    userActivityConfig,
    currentUserId
  })
)
